module.exports = __webpack_public_path__ + "static/media/logo_laraki.d10b5229.png";